import {
  Button,
  IconButton,
  InputAdornment,
  Menu,
  MenuItem,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableFooter,
  TableHead,
  TablePagination,
  TableRow,
  TextField,
} from '@material-ui/core';
import { MoreHoriz } from '@material-ui/icons';
import ArrowDropDownIcon from '@material-ui/icons/ArrowDropDown';
import DeleteForeverIcon from '@material-ui/icons/DeleteForever';
import SearchIcon from '@material-ui/icons/Search';
import VisibilityIcon from '@mui/icons-material/Visibility';
import React, { useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import DeletePopupModel from '../../../../../../shared/delete-popup/Delete-Popup';
import ListFilterMenu from '../../../../../../shared/list-filter-menu/List-Filter-Menu';
import TablePaginationActions from '../../../../../../shared/table-pagination/TablePaginationActions';
import { deleteGRERoom } from '../../../../../../utils/IntegrationsAPIUtils';
import { notificationManager } from '../../../../../../utils/NotificationUtils';
import { selectedHotelSelector } from '../../../../../property/propertySlice';
import {
  fetchGRERoomList,
  fetchSelectedRoom,
  greRoomsListSelector,
  greTemplatesSelector,
} from '../../../../configurationSlice';
import { stepDownLoaderCount, stepUpLoaderCount } from '../../../../../../utils/loaderSlice';

const GuestRoomExperienceRoom = (props) => {
  const {
    onViewToggleTemplate,
    page,
    rowsPerPage,
    onsetRowsPerPage,
    onsetPage,
    showLoader = () => {},
  } = props;
  const originalRooms = useSelector(greRoomsListSelector);
  const [initalList, setInitalList] = useState([]);
  const originalTemplates = useSelector(greTemplatesSelector);
  const [rooms, setRooms] = useState([]);
  const [selectedValue, setSelectedValue] = useState({
    id: '',
    name: '',
    title: '',
    description: '',
    status: false,
    anchorEl: null,
  });
  const [filterTargetButton, setFilterTargetButton] = useState(null);
  const [filterMenu, setFilterMenu] = useState([]);
  const dispatch = useDispatch();
  const selectedHotel = useSelector(selectedHotelSelector);
  const [tempSearchText, setTempSearchText] = useState('');
  const [searchButton, setSearchButton] = useState(true);
  const [filteredBaseList, setFilteredBaseList] = useState([]);

  useEffect(() => {
    if (originalRooms?.length) {
      const tempList = originalRooms?.map((room) => {
        let tempVal = { ...room };
        tempVal['templateName'] = originalTemplates?.find(
          (temp) => temp?.id === room?.templateId,
        )?.name;
        return tempVal;
      });

      setRooms(tempList);
      setInitalList(tempList);
      setTempSearchText('');
      setSearchButton(true);
    }
  }, [originalRooms]);

  useEffect(() => {
    const updatedFilterMenu = [
      {
        title: 'All',
        field: 'all',
        subMenu: [],
      },
    ];
    if (initalList.length) {
      const filterMenuTemplates = initalList?.map((obj) => {
        return {
          id: obj.templateName,
          name: obj.templateName,
          selected: false,
        };
      });
      const uniqueTemplateArray = filterMenuTemplates?.reduce((acc, current) => {
        const x = acc?.find((item) => item.id === current?.id);
        if (!x) {
          return acc.concat([current]);
        } else {
          return acc;
        }
      }, []);

      updatedFilterMenu.push({
        title: 'Template',
        field: 'templateName',
        subMenu: uniqueTemplateArray,
      });

      const filterMenuStatus = initalList.map((obj) => {
        return { id: obj.status, name: obj.status, selected: false };
      });

      const uniqueStatusArray = filterMenuStatus.reduce((acc, current) => {
        const x = acc?.find((item) => item?.id === current?.id);
        if (!x) {
          return acc.concat([current]);
        } else {
          return acc;
        }
      }, []);

      updatedFilterMenu.push({
        title: 'Status',
        field: 'status',
        subMenu: uniqueStatusArray,
      });

      setFilterMenu(updatedFilterMenu);
    }
  }, [initalList]);

  const setSearchText = (searchText) => {
    setTempSearchText(searchText);
    onsetPage(0);
    if (!searchText) {
      const baseList = filteredBaseList?.length ? filteredBaseList : initalList;
      setRooms(baseList);
      return;
    }
    const baseList = filteredBaseList?.length ? filteredBaseList : initalList;
    const filteredRows = baseList?.filter((item) => {
      return (
        item?.roomId.toString().includes(searchText.toLowerCase()) ||
        item?.templateName?.toLowerCase().includes(searchText.toLowerCase()) ||
        item?.status?.toLowerCase().includes(searchText.toLowerCase())
      );
    });
    setRooms(filteredRows);
  };

  const onViewDetails = (room, e, isClassDisabled) => {
    if (isClassDisabled) {
      dispatch(fetchSelectedRoom(selectedHotel, room.roomId));
    }
    if (e.target.className === 'MuiTableCell-root MuiTableCell-body') {
      dispatch(fetchSelectedRoom(selectedHotel, room.roomId));
      onViewToggleTemplate(true, false, room);
    }
  };

  const onClickView = (room, e) => {
    dispatch(fetchSelectedRoom(selectedHotel, room.roomId));
    onViewToggleTemplate(true, false, room);
  };

  const handleChangePage = (event, newPage) => {
    onsetPage(newPage);
  };

  const handleChangeRowsPerPage = (event) => {
    onsetRowsPerPage(parseInt(event.target.value, 10));
    onsetPage(0);
  };

  const handleCellMenuClick = (event, room) => {
    setSelectedValue({
      id: room.roomId,
      name: 'Room ' + room.roomId,
      title: '',
      description: '',
      status: false,
      anchorEl: event?.currentTarget,
      room: room,
    });
  };

  const handleFilterMenu = (event) => {
    setFilterTargetButton(event?.currentTarget);
    // setAnchorEl(event.currentTarget);
  };

  const handleFilter = (filterItems, field) => {
    const updatedFilterMenu = [...filterMenu];
    const currentRoomList = originalRooms?.map((room) => {
      let tempVal = { ...room };
      tempVal['templateName'] = originalTemplates?.find(
        (temp) => temp.id === room.templateId,
      )?.name;
      return tempVal;
    });
    if (field === 'all') {
      const defaultFilterList = updatedFilterMenu?.map((filtrMenuData) => {
        let subMenu = [];
        if (filtrMenuData.subMenu && filtrMenuData.subMenu.length > 0) {
          subMenu = filtrMenuData.subMenu?.map((subMenuData) => {
            return { ...subMenuData, selected: false };
          });
        }
        return { ...filtrMenuData, subMenu };
      });
      setFilterMenu(defaultFilterList);
      setRooms(currentRoomList);
      setFilteredBaseList(currentRoomList);
      onsetPage(0);
      return true;
    }
    updatedFilterMenu[updatedFilterMenu?.findIndex((o) => o.field === field)].subMenu = filterItems;
    setFilterMenu(updatedFilterMenu);
    const filterIdWithFields = [...updatedFilterMenu]
      .map((filterItem) => {
        const subMenuFiltersId = filterItem.subMenu
          ?.filter((fItem) => fItem.selected === true)
          ?.map((fItemId) => fItemId.id);
        if (subMenuFiltersId && subMenuFiltersId.length > 0) {
          return {
            id: subMenuFiltersId,
            field: filterItem.field,
          };
        } else return null;
      })
      .filter((item) => item !== null);
    const filteredRecords = currentRoomList?.filter((offer) => {
      const doesFilterSatisfy = filterIdWithFields?.map((filter) =>
        filter.id.includes(offer[filter.field]),
      );
      return !doesFilterSatisfy.includes(false);
    });
    onsetPage(0);
    setRooms(filteredRecords);
    setFilteredBaseList(filteredRecords);
  };

  const handleClose = () => {
    setSelectedValue({
      id: '',
      name: '',
      title: '',
      description: '',
      status: false,
      anchorEl: null,
      room: null,
    });
  };

  const handleDeletePopupOpen = () => {
    let val = { ...selectedValue };
    val['title'] = 'Are you sure you want to delete';
    val['description'] = 'This action cannot be reversed.';
    val['status'] = true;
    val['anchorEl'] = null;
    setSelectedValue(val);
  };

  const deleteRoom = async () => {
    handleClose();
    try {
      dispatch(stepUpLoaderCount());
      await deleteGRERoom(selectedHotel, selectedValue.id);
      dispatch(fetchGRERoomList(selectedHotel));
      notificationManager('success', 'Room configurations deleted successfully');
      setSelectedValue({
        id: '',
        key: '',
        name: '',
        title: '',
        description: '',
        status: false,
        anchorEl: null,
        group: null,
      });
    } catch (error) {
      if (error?.message) {
        notificationManager('danger', error?.message);
      } else {
        notificationManager('danger', 'Room configurations deletion failed');
      }
    } finally {
      dispatch(stepDownLoaderCount());
    }
  };

  const onDeleteCancel = () => {
    setSelectedValue({
      id: '',
      type: '',
      name: '',
      title: '',
      description: '',
      status: false,
      anchorEl: null,
    });
  };

  return (
    <>
      {selectedValue.id + '' !== '' && selectedValue.status === true && (
        <DeletePopupModel
          deletePopUp={selectedValue}
          onDelete={deleteRoom}
          onDeleteCancel={onDeleteCancel}
        />
      )}
      <div className='container mt-4 mb-4 px-0 child-view'>
        {
          <>
            <div className='row mx-2 d-flex'>
              <div className='col col-lg-4'>
                <TextField
                  className='w-100'
                  onChange={(e) => {
                    setSearchText(e.target.value);
                    setSearchButton(e?.target?.value ? false : true);
                  }}
                  label='Search'
                  value={tempSearchText}
                  InputProps={
                    searchButton && {
                      endAdornment: (
                        <InputAdornment position='end'>
                          <IconButton>
                            <SearchIcon />
                          </IconButton>
                        </InputAdornment>
                      ),
                    }
                  }
                />
              </div>
              <div className='col-12 col-lg-8 pt-3 pt-lg-0 d-flex justify-content-end'>
                <>
                  <Button
                    variant='outlined'
                    color='secondary'
                    size='large'
                    endIcon={<ArrowDropDownIcon />}
                    onClick={(e) => {
                      handleFilterMenu(e);
                    }}
                    className={
                      filterMenu?.some((f) => f?.subMenu?.some((s) => s?.selected))
                        ? 'filterButton'
                        : 'showpopup'
                    }
                  >
                    Filter
                  </Button>
                  <ListFilterMenu
                    menu={filterMenu}
                    targetEl={filterTargetButton}
                    handleFilterClose={() => setFilterTargetButton(null)}
                    handleFilter={(items, field) => {
                      handleFilter(items, field);
                    }}
                  />
                </>
              </div>
            </div>

            <div className='row mx-2 d-flex mt-4'>
              <TableContainer>
                <Table className='list-table' aria-label='simple table'>
                  <TableHead>
                    <TableRow>
                      <TableCell className='w-30'>Room Number</TableCell>
                      <TableCell className='w-30'>Template</TableCell>
                      <TableCell className='d-flex justify-content-center'>Status</TableCell>
                      <TableCell className='w-10'></TableCell>
                    </TableRow>
                  </TableHead>
                  <TableBody>
                    {(rowsPerPage > 0
                      ? rooms.slice(page * rowsPerPage, page * rowsPerPage + rowsPerPage)
                      : rooms
                    ).map((room, i) => (
                      <TableRow
                        key={i}
                        className='border-white pointer'
                        onClick={(e) => {
                          onViewDetails(room, e);
                        }}
                      >
                        <TableCell>{room?.roomId}</TableCell>
                        <TableCell>{room?.templateName || '----'}</TableCell>
                        <TableCell onClick={(e) => onViewDetails(room, e, true)}>
                          <div className='d-flex justify-content-center'>
                            <div
                              className={`${
                                room?.status === 'online'
                                  ? 'pill-online'
                                  : room.status === 'pending'
                                  ? ' pill-pending'
                                  : room.status === 'error'
                                  ? 'pill-error'
                                  : 'pill-unassigned'
                              } 
                       pill d-flex justify-content-center align-items-center`}
                            >
                              <span className='ms-1'>
                                {room.status === 'pending'
                                  ? 'Pending'
                                  : room.status === 'online'
                                  ? 'Online'
                                  : room.status === 'error'
                                  ? 'Error'
                                  : 'Unassigned'}
                              </span>
                            </div>
                          </div>
                        </TableCell>

                        <TableCell align='right'>
                          <Button
                            aria-controls='simple-menu'
                            aria-haspopup='true'
                            onClick={(e) => {
                              handleCellMenuClick(e, room);
                            }}
                          >
                            <MoreHoriz />
                          </Button>
                          <Menu
                            id={i}
                            anchorEl={selectedValue?.anchorEl}
                            disableRestoreFocus
                            MenuListProps={{ autoFocusItem: false }}
                            keepMounted
                            open={
                              Boolean(selectedValue.anchorEl) && selectedValue.id === room.roomId
                            }
                            onClose={handleClose}
                            className='shadow'
                          >
                            {/* this might be needed in the future */}
                            {/* <MenuItem
                                className="pe-4"
                                onClick={(e) => {
                                  onOpenDrawer(GUEST_ROOM_EXPERIENCE_ROOM_TAB_EDIT);
                                }}
                              >
                                <CreateIcon className="me-2 action-menu-icon" />
                                Edit
                              </MenuItem> */}
                            <MenuItem
                              className='pe-4'
                              onClick={(e) => {
                                onClickView(selectedValue.room, e);
                              }}
                            >
                              <VisibilityIcon className='me-2 action-menu-icon' />
                              View
                            </MenuItem>
                            <MenuItem
                              className='pe-4'
                              onClick={(e) => {
                                handleDeletePopupOpen();
                              }}
                            >
                              <DeleteForeverIcon className='me-2 action-menu-icon' />
                              Delete
                            </MenuItem>
                          </Menu>
                        </TableCell>
                      </TableRow>
                    ))}
                  </TableBody>
                  <TableFooter>
                    <TableRow className='paginator'>
                      <TablePagination
                        rowsPerPageOptions={[5, 10, 25, { label: 'All', value: -1 }]}
                        count={rooms.length}
                        rowsPerPage={rowsPerPage}
                        page={page}
                        SelectProps={{
                          inputProps: { 'aria-label': 'rows per page' },
                          native: true,
                        }}
                        onPageChange={handleChangePage}
                        onRowsPerPageChange={handleChangeRowsPerPage}
                        ActionsComponent={TablePaginationActions}
                      />
                    </TableRow>
                  </TableFooter>
                </Table>
              </TableContainer>
            </div>
          </>
        }
      </div>
    </>
  );
};

export default GuestRoomExperienceRoom;
